'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.accessTokenSelector = exports.organizationSelector = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.handleFeedback = handleFeedback;
exports.default = feedbackRootSage;

var _effects = require('redux-saga/effects');

var _FeedbackActions = require('../actions/FeedbackActions');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(handleFeedback),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(waitForFeedback),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(feedbackRootSage);

function handleFeedback(sagaParams, action) {
    var OpenrestService, payload, feedback, onSendError, onSendSuccess, organizationId, accessToken, feedbackRequest;
    return _regenerator2.default.wrap(function handleFeedback$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    OpenrestService = sagaParams.OpenrestService;
                    payload = action.payload;
                    feedback = payload.feedback, onSendError = payload.onSendError, onSendSuccess = payload.onSendSuccess;
                    _context.next = 5;
                    return (0, _effects.select)(organizationSelector) || {};

                case 5:
                    organizationId = _context.sent.id;
                    _context.next = 8;
                    return (0, _effects.select)(accessTokenSelector);

                case 8:
                    accessToken = _context.sent;
                    feedbackRequest = _lodash2.default.extend({}, { organizationId: organizationId }, feedback);
                    _context.prev = 10;
                    _context.next = 13;
                    return (0, _effects.call)(function () {
                        return OpenrestService.request({
                            request: {
                                type: 'feedback',
                                accessToken: accessToken,
                                feedback: feedbackRequest
                            } });
                    });

                case 13:

                    (onSendSuccess || function () {})();
                    _context.next = 19;
                    break;

                case 16:
                    _context.prev = 16;
                    _context.t0 = _context['catch'](10);


                    (onSendError || function () {})();

                case 19:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[10, 16]]);
}

// ============================================================================
// PRIVATE HELPER METHODS
// ============================================================================

var organizationSelector = exports.organizationSelector = function organizationSelector(state) {
    return state.organization.organization;
};
var accessTokenSelector = exports.accessTokenSelector = function accessTokenSelector(state) {
    return state.jointLoginInfo.accessToken;
};

// ============================================================================
// WATCHERS
// ============================================================================

function waitForFeedback(sagaParams) {
    return _regenerator2.default.wrap(function waitForFeedback$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.takeEvery)(_FeedbackActions.types.FEEDBACK, handleFeedback.bind(null, sagaParams));

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

// ============================================================================
// DEFAULT SAGA EXPORT
// ============================================================================

function feedbackRootSage(sagaParams) {
    return _regenerator2.default.wrap(function feedbackRootSage$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return (0, _effects.all)([(0, _effects.fork)(waitForFeedback.bind(null, sagaParams))]);

                case 2:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}